import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ua from 'ua-parser-js';
import { breakpoints } from '../helpers/constants';

gsap.registerPlugin(ScrollTrigger);

const agent = ua(navigator.userAgent);
class LogoRow extends Component {
  setupDefaults() {
    this.dom = {
      line: this.el.querySelector('.logo-row__line'),
      triggerContainer: this.el.querySelector('.logo-row__trigger-container'),
      logo: this.el.querySelector('.logo-row__logo-container'),
      infoContainer: this.el.querySelector('.logo-row__info'),
      container: this.el.querySelector('.logo-row__inner')
    };

    this.isMobileSafari = agent.browser.name === 'Mobile Safari';

    if (!this.isMobileSafari) {
      this.initScroll();
    } else {
      this.el.classList.add('logo-row--mobile-safari');
    }
  }

  addListerners() {
    window.addEventListener('resize', () => {
      if (!this.isMobileSafari) {
        ScrollTrigger.refresh();
        ScrollTrigger.update();
      }
    });
  }

  initScroll() {
    ScrollTrigger.matchMedia({
      [`(max-width: ${breakpoints.tablet - 1}px)`]: () => {
        this.dom.logo.style.top = 0;
        this.dom.container.style.height = 'auto';
        const mobileAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: this.dom.triggerContainer,
            start: 'top top',
            end: 'bottom center',
            pin: this.dom.triggerContainer,
            scrub: true
          }
        });
        mobileAnimation.to(this.dom.line, { height: '100%' }, '<-0.5').to(
          this.dom.logo,
          {
            y: `${
              this.dom.triggerContainer.offsetHeight -
              this.dom.logo.offsetHeight
            }px`
          },
          '>-0.5'
        );
      },
      [`(min-width: ${breakpoints.tablet}px)`]: () => {
        this.fromTabletNavigation(525);
      },
      [`(min-width: ${breakpoints.tabletLandscape}px)`]: () => {
        this.fromTabletNavigation(525);
      },
      [`(min-width: ${breakpoints.desktop}px)`]: () => {
        this.fromTabletNavigation(601);
      },
      [`(min-width: ${breakpoints.wide}px)`]: () => {
        this.fromTabletNavigation(731);
      }
    });
  }

  fromTabletNavigation(lineHeight) {
    this.dom.container.style.height = `${
      this.dom.infoContainer.offsetHeight + lineHeight
    }px`;
    this.dom.line.style.height = `${lineHeight - 5}px`;
    this.setLogoPosition();
    const bottomOffset = this.dom.infoContainer.offsetHeight;

    gsap.timeline({
      scrollTrigger: {
        trigger: this.dom.container,
        start: 'top top',
        end: `bottom ${bottomOffset}px`,
        pin: this.dom.infoContainer,
        pinSpacing: false,
        scrub: true
      }
    });
  }

  setLogoPosition() {
    const infoPaddingTop = window
      .getComputedStyle(this.dom.infoContainer)
      .getPropertyValue('padding-top')
      ?.replace('px', '');
    this.dom.logo.style.top = `-${
      this.dom.triggerContainer.offsetTop - infoPaddingTop
    }px`;
  }
}

export default LogoRow;
